import ApplicationController from "./application_controller.js";

export default class extends ApplicationController {
  static values = {
    documentId: String,
    caseId: String,
    actionUrl: String,
    checkedAttribute: String,
    label: String,
    type: String,
  };

  connect() {
    this.render();
  }

  render() {
    this.element.innerHTML = `<div class="checkbox-switch size-small">
      <div class="checkbox-switch-input">
        <input type="checkbox" name="${this.documentIdValue}" id="${this.documentIdValue}_id"
          aria-labelledby="${this.documentIdValue}" aria-describedby="${this.documentIdValue}Desc" ${this.checkedAttributeValue} 
          data-action="click->toggle#update">
        <div class="checkbox-switch-btn">
          <span class="switch-handle"></span>
          <span class="switch-inner">
            <span class="switch-inner-checked fa fa-check"></span>
            <span class="switch-inner-unchecked fa fa-times"></span>
          </span>
        </div>
      </div>
    </div>`;
  }

  update(ev) {
    const url = new URL(this.actionUrlValue.replace("servlet/", "internal/"));
    const cleanUrl = url.href.split("?")[0];
    let isPublic = null;
    let isSummary = null;

    // Check the conditions for setting isPublic and isSummary
    if (this.typeValue === "public") {
      isPublic = ev.target.checked;
    }
    if (this.typeValue === "summary") {
      isSummary = ev.target.checked;
    }

    const params = new URLSearchParams();

    if (isPublic !== null) {
      params.append("isPublic", isPublic);
    }

    if (isSummary !== null) {
      params.append("isSummary", isSummary);
    }

    if (this.labelValue) {
      params.append("label", this.labelValue);
    }

    // Make the fetch request
    fetch(cleanUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: params,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            "Network response was not ok: " + response.statusText,
          );
        }
        console.log("Request was successful");
      })
      .catch((error) =>
        console.error("There was a problem with the fetch operation:", error),
      );
  }
}
